import { Fragment, Slice } from 'prosemirror-model';
import { useCallback, useContext, useMemo } from 'react';
import { createInsertVideoButton } from '../../draft-transplant/createInsertVideoButton';
import GoVideoDialog from '../../draft-transplant/GoVideoDialog';
import { EditorConfigContext } from '../contexts/EditorConfigContext';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { makeLinkNode } from '../plugins/link/LinkUtils';
import { convertToPlaintextState } from '../utils/plaintextUtils';
import { getGlobalVars } from '../utils/globalVarUtil';
import { jsx as _jsx } from "react/jsx-runtime";
const TICKET_OBJECT_TYPE = 'TICKET';
export default function InsertVideo(props) {
  const {
    objectType,
    recipientEmail,
    insertWithThumbnail,
    Button,
    onInsertComplete,
    closeModal,
    useInsertMenuVersion
  } = props;
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const {
    usePlaintextMode,
    plaintextOptions
  } = getGlobalVars(useContext(EditorConfigContext));
  const VideoButton = useMemo(() => createInsertVideoButton({
    CustomButtonComponent: Button
  }), [Button]);
  const handleVideoInsertion = useCallback(videoData => {
    const videoUrl = videoData.get('url');
    const videoThumbnailUrl = videoData.get('thumbnailSrc');
    const videoTitle = videoData.get('videoTitle');
    const {
      schema
    } = editorState;
    let tr = editorState.tr;
    if (insertWithThumbnail) {
      const videoNode = schema.nodes.videoBlock.create({
        videoTitle,
        videoUrl,
        videoThumbnailUrl
      });
      tr = tr.replaceSelection(new Slice(Fragment.fromArray([schema.nodes.paragraph.create(), videoNode, schema.nodes.paragraph.create()]), 0, 0));
    } else {
      const linkNode = makeLinkNode(schema, videoUrl, videoTitle, true, false);
      tr = tr.replaceSelection(new Slice(Fragment.from(linkNode), 0, 0));
    }
    setEditorState(usePlaintextMode ? convertToPlaintextState(editorState.apply(tr), plaintextOptions) : editorState.apply(tr));
    onInsertComplete();
  }, [insertWithThumbnail, editorState, setEditorState, onInsertComplete, usePlaintextMode, plaintextOptions]);
  if (useInsertMenuVersion) {
    return /*#__PURE__*/_jsx(GoVideoDialog, {
      isInServiceHub: objectType === TICKET_OBJECT_TYPE,
      onClose: e => closeModal(e),
      onChange: handleVideoInsertion,
      recipientEmail: recipientEmail
    });
  }
  return /*#__PURE__*/_jsx(VideoButton
  // @ts-expect-error ts-migrate error
  , {
    onChange: handleVideoInsertion,
    objectType: objectType,
    recipientEmail: recipientEmail,
    useProsemirror: true
  });
}